/** Rotating byline names for posts that use the shared team placeholder. */
export const BLOG_AUTHORS = [
  'Rohan Kumar',
  'Rahul Yadav',
  'Intizaar Khan',
  'Avni Agarwal',
  'Ankish Agarwal',
  'Shuvam',
  'Amit Saini',
  'Aditya Singh',
] as const;

const LEGACY_TEAM_LABEL = 'Geofleet Team';

/**
 * Stable, deterministic author per post slug so the same article always shows the same name.
 * Replace `Geofleet Team` with one of {@link BLOG_AUTHORS}; any other string is returned as-is.
 */
export function resolveBlogAuthor(slug: string, author: string): string {
  if (author !== LEGACY_TEAM_LABEL) return author;
  let h = 0;
  for (let i = 0; i < slug.length; i++) {
    h = (Math.imul(31, h) + slug.charCodeAt(i)) | 0;
  }
  const idx = Math.abs(h) % BLOG_AUTHORS.length;
  return BLOG_AUTHORS[idx]; 
}
